/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect, useMemo } from "react";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

// API
import { apiGetJanaTerakhir, apiGetTerimaanTerakhir } from "api/dashboard";

// Helper to format date to DD/MM/YYYY
const formatDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-GB");
};

export default function data() {
  const [raw, setRaw] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Get user context to determine which API to call
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const isKaunterUser = user?.menu?.toUpperCase() === "KAUNTER" || user?.id_pengguna?.toLowerCase() === "huda";

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        // Fetch appropriate data based on user type
        const list = isKaunterUser 
          ? await apiGetTerimaanTerakhir()
          : await apiGetJanaTerakhir();
        if (!alive) return;
        setRaw(Array.isArray(list) ? list : []);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [isKaunterUser]);

  const columns = useMemo(
    () => {
      if (isKaunterUser) {
        // KEW: Show Zon, Bahagian, Tarikh Terakhir
        return [
          { Header: <div style={{ textAlign: "center", width: "100%" }}>Zon</div>, accessor: "zon", width: "33%", align: "left" },
          { Header: <div style={{ textAlign: "center", width: "100%" }}>Bahagian</div>, accessor: "bahagian", width: "33%", align: "center" },
          { Header: <div style={{ textAlign: "center", width: "100%" }}>Tarikh Terakhir Terimaan</div>, accessor: "tarikh_terakhir_terimaan", width: "34%", align: "center" },
        ];
      } else {
        // UEU: Show Zon, Tarikh Terakhir Jana (existing)
        return [
          { Header: <div style={{ textAlign: "center", width: "100%" }}>Zon</div>, accessor: "zon", width: "50%", align: "left" },
          { Header: <div style={{ textAlign: "center", width: "100%" }}>Tarikh Terakhir Jana</div>, accessor: "tarikh_terakhir_jana", width: "50%", align: "center" },
        ];
      }
    },
    [isKaunterUser]
  );

  const rows = useMemo(() => {
    const sorted = [...(raw || [])].sort((a, b) => {
      // Sort by bahagian first (for KEW), then by zon
      const bahagianCompare = (a.bahagian || "").localeCompare(b.bahagian || "");
      if (bahagianCompare !== 0) return bahagianCompare;
      return (a.zon || "").localeCompare(b.zon || "");
    });
    
    if (isKaunterUser) {
      // KEW: Show Zon, Bahagian, Tarikh Terakhir Terimaan
      return sorted.map((r) => ({
        zon: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {r.zon || "-"}
          </MDTypography>
        ),
        bahagian: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {r.bahagian || "-"}
          </MDTypography>
        ),
        tarikh_terakhir_terimaan: (
          <MDTypography variant="caption" color="text" fontWeight="regular">
            {formatDate(r.tarikh_terakhir)}
          </MDTypography>
        ),
      }));
    } else {
      // UEU: Show Zon, Tarikh Terakhir Jana (existing)
      return sorted.map((r) => ({
        zon: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {r.zon || "-"}
          </MDTypography>
        ),
        tarikh_terakhir_jana: (
          <MDTypography variant="caption" color="text" fontWeight="regular">
            {formatDate(r.tarikh_terakhir)}
          </MDTypography>
        ),
      }));
    }
  }, [raw, isKaunterUser]);

  return { columns, rows };
}
